import { render } from "./EditMaterial.vue?vue&type=template&id=72c6eaab&scoped=true"
import script from "./EditMaterial.vue?vue&type=script&lang=js"
export * from "./EditMaterial.vue?vue&type=script&lang=js"

import "./EditMaterial.vue?vue&type=style&index=0&id=72c6eaab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c6eaab"]])

export default __exports__